import { normalizeSnapshot, validateMatchSnapshot } from "./match-schema.js";

function validSnapshot(value) {
  if (!value) return null;
  const checked = validateMatchSnapshot(normalizeSnapshot(value));
  return checked.ok ? checked.value : null;
}

function revisionOf(match) {
  return Number.isFinite(Number(match?._stateRevision)) ? Number(match._stateRevision) : 0;
}

function savedAtOf(match) {
  return Number.isFinite(Number(match?._savedAt)) ? Number(match._savedAt) : 0;
}

export function selectNewestActiveSnapshot(indexedDbSnapshot, emergencySnapshot) {
  const indexedDb = validSnapshot(indexedDbSnapshot);
  const emergency = validSnapshot(emergencySnapshot);
  if (!emergency) return indexedDb;
  if (!indexedDb) return emergency;

  if (emergency.id !== indexedDb.id) {
    // Different matches: revisions aren't comparable, so use the wall-clock
    // save stamp. This keeps the intended behavior (a brand-new match whose
    // async IndexedDB write didn't finish before unload wins via its newer
    // stamp) while a stale localStorage copy — left behind by an old quota
    // failure — can no longer resurrect a long-finished match.
    const emergencyAt = savedAtOf(emergency);
    const indexedDbAt = savedAtOf(indexedDb);
    if (emergencyAt || indexedDbAt) return emergencyAt >= indexedDbAt ? emergency : indexedDb;
    return emergency; // legacy snapshots without stamps: keep old behavior
  }
  return revisionOf(emergency) >= revisionOf(indexedDb) ? emergency : indexedDb;
}

export function prepareActiveSnapshot(match) {
  return validSnapshot(match);
}
